export function initReportSwiper() {
    if (!document.querySelector(".reports-swiper")) return;

    new Swiper(".reports-swiper", {
        wrapperClass: "reports-container",
        slideClass: "article-item",
        slidesPerView: 4,
        spaceBetween: 24,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        loop: false,
        breakpoints: {
            0:    { slidesPerView: 2 },
            640:  { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1280: { slidesPerView: 4 },
        },
    });
}
